export const searchPlaceDetail = (
  lat: number,
  lng: number,
  type: App.PlaceType,
) => [lat, lng, type] as const
